// src/components/PageNotFound.tsx
import React from "react";
import { Link } from "react-router-dom";
import { Stethoscope } from "lucide-react";

const PageNotFound: React.FC = () => {
	return (
		<div className="flex items-center justify-center h-screen animate-bg-fade">
			<div className="flex flex-col items-center justify-center text-center p-12">
				<Stethoscope size={220} />
				<h1 className="text-4xl font-bold text-red-600 mb-4">
					404 - Page Not Found
				</h1>
				<p className="text-lg text-gray-700 mb-6">
					The page you are looking for might have been removed or is
					temporarily unavailable.
				</p>
				<Link
					to="/"
					className="bg-blue-600 text-white px-6 py-3 rounded-md hover:bg-blue-700 transition"
				>
					Go to Home
				</Link>
			</div>
		</div>
	);
};

export default PageNotFound;
